import React, { useState } from 'react';
import Title from '../shared/Title';
import Spinner from '../shared/Spinner';
import { Charts } from './Charts';
import { PlayersFilter } from './PlayersFilter';
import { LineupsFilter, SingleLineupFilters } from './LineupsFilter';
import { DisplayFilter } from './DisplayFilter';
import { Scores } from './Scores';
import ItemSelector from '../shared/ItemSelector';
import { FourFactorsSummary } from './FourFactorsSummary';
import { ShootingProfileSummary } from './ShootingProfileSummary';
import { MultiSelect } from '../shared/MultiSelect';
import {
  STAT_TYPE_FOUR_FACTORS,
  STAT_TYPE_SCORING,
  STAT_TYPE_PROFILE,
} from '../../shared/constants';
import { createOverflow } from '../../lib/format';

export const LineupExplorer = ({
  team,
  games,
  season,
  pathTo,
  analysis,
  filter,
  players,
  display,
  onHandleGameChange,
  isNBA,
}) => {
  const isLoading = !analysis;
  const isLoadingGames = !games;
  const { lineups, totals } = analysis || {};
  const [chartType, setChartType] = useState(STAT_TYPE_SCORING);

  const hasScores = totals && totals.total_minutes !== null;

  const handleClick = ({ data }) => {
    display.lineups.onChange(data.lineupId);
  };

  const changeChartType = chartType => {
    setChartType(chartType);
  };

  const statTypes = [
    {
      id: STAT_TYPE_SCORING,
      name: 'Scoring',
    },
    {
      id: STAT_TYPE_FOUR_FACTORS,
      name: 'Four Factors',
    },
    {
      id: STAT_TYPE_PROFILE,
      name: 'Shooting Profile',
    },
  ];

  const overflow = createOverflow(team, season);

  let ChartComponent;
  if (chartType === STAT_TYPE_FOUR_FACTORS) ChartComponent = FourFactorsSummary;
  else if (chartType === STAT_TYPE_PROFILE)
    ChartComponent = ShootingProfileSummary;
  else ChartComponent = Scores;

  return (
    <div className="s-lineup-explorer">
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle={'Lineup Explorer'}
        overflow={overflow}
      />
      <div className="action-bar">
        <MultiSelect
          className="s-lineup-explorer__multi-game-selector"
          empty="Select game(s) to filter by..."
          items={
            games &&
            games.map(mapped => ({ value: mapped.id, label: mapped.name }))
          }
          onChange={onHandleGameChange}
          isSearchable={true}
          isLoading={isLoadingGames}
          wrapperClassname={'s-lineup-explorer__multi-game-selector--wrapper'}
          loadingMessage={'Loading games...'}
        />

        <ItemSelector
          className="s-lineup-explorer__game-selector"
          items={statTypes}
          value={chartType}
          onChange={changeChartType}
        />
      </div>
      <div className="filter-container">
        <LineupsFilter {...filter} isNBA={isNBA} />
        <PlayersFilter {...players} />
      </div>

      {hasScores && <ChartComponent totals={totals} />}

      {!isLoading && <DisplayFilter {...display} />}

      {!isLoading && <SingleLineupFilters {...filter} />}

      {isLoading ? (
        <Spinner />
      ) : (
        <Charts
          selectedLineupId={display.lineups.value}
          lineups={lineups}
          displayType={chartType}
          onClick={handleClick}
        />
      )}
    </div>
  );
};
